import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface IntroProps {
  headline: string;
  keywords: string[];
  introIcon?: string;
  frame: number;
  fps: number;
}

export const InkPorcelainIntro: React.FC<IntroProps> = ({
  headline,
  keywords,
  introIcon,
  frame,
  fps,
}) => {
  return (
          <div
            style={{
              width: "88%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: "24px",
              margin: "auto",
            }}
          >
            <div
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "13px",
                fontWeight: 700,
                color: "#0196AF", // teal
                letterSpacing: "6px",
                textTransform: "uppercase",
              }}
            >
              🚨 {keywords?.[0] || "EXCLUSIVE INTEL"}
            </div>

            <h1
              style={{
                fontFamily: "'Playfair Display', serif",
                fontStyle: "italic",
                fontSize: "76px",
                fontWeight: 700,
                lineHeight: 1.15,
                letterSpacing: "-1px",
                margin: 0,
                color: "#fdfffc", // porcelain/off-white for high contrast on dark bg
                textShadow: "0 2px 8px rgba(0,0,0,0.5)",
              }}
            >
              {headline}
            </h1>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "60%",
                marginTop: "10px",
              }}
            >
              <div style={{ flex: 1, height: "1.5px", background: "linear-gradient(90deg, transparent, #F45E2E)" }} />
              <div style={{ width: "8px", height: "8px", background: "#FBD839", transform: "rotate(45deg)" }} />
              <div style={{ flex: 1, height: "1.5px", background: "linear-gradient(90deg, #F45E2E, transparent)" }} />
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
